export default {
      id: "customs-usage",
      viewBox: "0 0 98 78",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#customs-usage",
      toString: function () {
        return this.url;
      }
    }